import { DEFAULT_TIME_PER_ATHLETE } from "./constants";
import { Athlete } from "../types";

export function secondsToString(fullTimeInSeconds: number) {

    const minutes = Math.floor(fullTimeInSeconds / 60);
    const seconds = Math.floor(fullTimeInSeconds - minutes * 60);

    if (minutes === 0) {
        return `${seconds}s`
    }

    return `${minutes}:${seconds.toString().padStart(2, "0")}m`;
}

/**
 * Returns the most common time value among athletes.
 * Falls back to DEFAULT_TIME_PER_ATHLETE if no athletes exist.
 */
export function getMajorityTime(athletes: Athlete[]): number {
    if (athletes.length === 0) {
        return DEFAULT_TIME_PER_ATHLETE;
    }

    // Count occurrences of each time value
    const timeCounts = new Map<number, number>();
    for (const athlete of athletes) {
        timeCounts.set(athlete.time, (timeCounts.get(athlete.time) || 0) + 1);
    }

    // Find the time with the highest count
    let majorityTime = DEFAULT_TIME_PER_ATHLETE;
    let maxCount = 0;
    timeCounts.forEach((count, time) => {
        if (count > maxCount) {
            maxCount = count;
            majorityTime = time;
        }
    });

    return majorityTime;
}
